import moment from "moment";
import "moment/locale/fr";
moment.locale("fr");

export default moment;
